// @flow
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import React, { Component } from 'react';
import { buildCanonicalUrl } from '../../utils/pagination';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Form from 'react-bootstrap/lib/Form';
import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Helmet from 'react-helmet';
import isEqual from 'react-fast-compare';
import ReactPaginate from 'react-paginate';
import styles from './PaginationWrapper.module.scss';

type Props = {
    availableViews: any[],
    baseUrl: string,
    canonicalURL?: string,
    filteredItemCount: number,
    intl: intlShape,
    onPageChange: Function,
    onPageSizeChange: Function,
    onSubmit: Function,
    page: number,
    pageSize: number | 'all',
    paginatorContainerOverrideClass: string,
    paginatorOverrideClass: string,
    paginatorViewCountOverrideClass: string,
    pathname: string,
    totalItemsCount: number,
    totalPages?: number,
};

class PaginationWrapper extends Component<Props> {
    static defaultProps = {
        baseUrl: '',
        filteredItemCount: 0,
        page: 0,
        paginatorContainerOverrideClass: '',
        paginatorOverrideClass: '',
        paginatorViewCountOverrideClass: '',
        totalItemsCount: 0,
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    mapAvailableViews = (option: string, index: number) => (
        <option key={index} value={option}>
            {option === 'all' ? this.props.intl.formatMessage({ id: option }) : option}
        </option>
    );

    hrefBuilder = (pathname: string, pageNumber: number) => {
        const url = buildCanonicalUrl(pathname, pageNumber);
        return url;
    };

    handlePageChange = event => this.props.onPageChange(event.selected);
    handlePageSizeChange = event => this.props.onPageSizeChange(event.target.value);

    render() {
        const {
            availableViews,
            baseUrl,
            canonicalURL,
            onSubmit,
            page: queryPage,
            pageSize,
            paginatorOverrideClass,
            paginatorContainerOverrideClass,
            paginatorViewCountOverrideClass,
            pathname,
            totalItemsCount,
            totalPages,
        } = this.props;

        let { filteredItemCount } = this.props;

        if (typeof filteredItemCount === 'undefined' || global.__SERVER__) {
            filteredItemCount = totalItemsCount;
        }

        const itemsToDisplay = typeof pageSize === 'number' ? pageSize : totalItemsCount;
        const numPages = totalPages ? totalPages : Math.ceil(filteredItemCount / itemsToDisplay);
        const page = queryPage > numPages ? numPages : queryPage;

        const nextButtonClassName = numPages === page ? styles.grayed : '';
        const prevButtonClassName = page === 1 ? styles.grayed : '';
        const canonical = canonicalURL ? `${baseUrl}${canonicalURL}` : `${baseUrl}${pathname}`;

        let nextLink = '';
        const nextUrl = this.hrefBuilder(canonical, page + 1);
        if (numPages !== page) {
            nextLink = <link rel="next" href={nextUrl} />;
        }
        const currentLink = <link rel="canonical" href={this.hrefBuilder(canonical, page)} />;
        let prevLink = '';
        const prevUrl = this.hrefBuilder(canonical, page - 1);
        if (page > 1) {
            prevLink = <link rel="prev" href={prevUrl} />;
        }

        return (
            <div className={`${styles['pagination-container']} ${paginatorContainerOverrideClass}`}>
                <Helmet>
                    {nextLink}
                    {currentLink}
                    {prevLink}
                </Helmet>
                <div />
                <ReactPaginate
                    activeClassName="active"
                    breakLabel={<span className={`${styles.break} ${styles.disabled}`}>…</span>}
                    containerClassName={`${styles.paginator} ${paginatorOverrideClass}`}
                    hrefBuilder={num => this.hrefBuilder(pathname, num)}
                    forcePage={page - 1}
                    marginPagesDisplayed={1}
                    nextLabel={
                        <span className={nextButtonClassName}>
                            <FormattedMessage id="next" />{' '}
                            <FontAwesomeIcon className={styles.chevron} icon={faChevronRight} />
                        </span>
                    }
                    onPageChange={this.handlePageChange}
                    pageCount={numPages}
                    pageRangeDisplayed={2}
                    previousLabel={
                        <span className={prevButtonClassName}>
                            <FontAwesomeIcon className={styles.chevron} icon={faChevronLeft} />{' '}
                            <FormattedMessage id="previous" />
                        </span>
                    }
                    subContainerClassName="pages pagination"
                />
                <Form
                    className={`${styles['pagination-view-count']} ${paginatorViewCountOverrideClass}`}
                    inline
                    onSubmit={onSubmit}
                >
                    <FormGroup className={styles['page-size']} controlId="view">
                        <ControlLabel>
                            <FormattedMessage id="view" />
                            :&nbsp;
                        </ControlLabel>
                        <FormControl
                            value={pageSize}
                            componentClass="select"
                            placeholder="select"
                            onChange={this.handlePageSizeChange}
                        >
                            {availableViews.map(this.mapAvailableViews)}
                        </FormControl>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default injectIntl(PaginationWrapper);
